export const merchantInfoRouter = [
  {
    path: '/merchantInfo',
    name: 'merchantInfo',
    component: () => import('@/views/merchantInfo'),
    meta: {
      title: '商户信息',
      keepAlive: true
    }
  },
  {
    path: '/merchantInfo/basicInfo',
    name: 'basicInfo',
    component: () => import('@/views/merchantInfo/basicInfo'),
    meta: {
      title: '基本信息'
    }
  },
  {
    path: '/merchantInfo/signInfo',
    name: 'signInfo',
    component: () => import('@/views/merchantInfo/signInfo'),
    meta: {
      title: '签约信息'
    }
  },
  {
    path: '/merchantInfo/blocDetail',
    name: 'blocDetail',
    component: () => import('@/views/merchantInfo/blocDetail'),
    meta: {
      title: '所属集团'
    }
  },
  {
    path: '/merchantInfo/mchIdChange',
    name: 'mchIdChange',
    component: () => import('@/views/merchantInfo/mchIdChange'),
    meta: {
      title: '收款编号更换'
    }
  }
]
